import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Container, Table } from "reactstrap"
import {
  getCandidateTheoreticalAssessmentDetails,
  getTheoreticalAssessmentQuestions,
  submitTheoreticalParticipantAssessment,
} from "store/actions/theoreticalTrainingAction"
import { showAlert } from "store/reducers/alertReducer"

const ViewAssessment = ({ selectedItem, toggle1, getAllData }) => {
  const {
    isGettingDetails,
    theoreticalAssessmentQuestions,
    totalAllowTime,
    isLoading,
    participantAssessmentDetails,
    participantAssessmentQuestions,
  } = useSelector(state => state.TheoreticalTraining)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    getDetailsData()
  }, [])

  const getDetailsData = () => {
    dispatch(
      getCandidateTheoreticalAssessmentDetails(selectedItem?.participant_uuid)
    )
  }

  const [selectedAnswers, setSelectedAnswers] = useState({})

  useEffect(() => {
    if (participantAssessmentDetails?.assessments?.length) {
      const selectedData = {}
      participantAssessmentDetails?.assessments?.forEach(assessment => {
        assessment.questions.forEach(q => {
          selectedData[q.question_id] = { optionId: q.option_id }
        })
      })
      setSelectedAnswers(selectedData)
    }
  }, [participantAssessmentDetails])

  return (
    <div className="">
      {isGettingDetails ? (
        <Spinners />
      ) : (
        <Container fluid>
          <div className="interview_container1 candidate_interview_container">
            <div className="left">
              <div className="row my-3">
                <div className="col-lg-6">
                  <h3>{t("User Details")}:</h3>
                  <Table bordered responsive>
                    <tbody>
                      <tr>
                        <th>{t("Name")}</th>
                        <td>{participantAssessmentDetails?.user?.name}</td>
                      </tr>
                      <tr>
                        <th>{t("Phone Number")}</th>
                        <td>
                          <p className="ltr fit_content">
                            {participantAssessmentDetails?.user?.phone}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>{t("National Id")}</th>
                        <td>
                          {participantAssessmentDetails?.user?.national_id}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <div className="col-lg-6">
                  <h3>{t("Score Details")}:</h3>
                  <Table bordered responsive>
                    <tbody>
                      <tr>
                        <th>{t("Job Details")}</th>
                        <td>{participantAssessmentDetails?.job_details}</td>
                      </tr>
                      <tr>
                        <th>{t("Attended By")}</th>
                        <td>{participantAssessmentDetails?.attendedBy}</td>
                      </tr>
                      <tr>
                        <th>{t("Attended")}</th>
                        <td>
                          {participantAssessmentDetails?.is_attended
                            ? t("Yes")
                            : t("No")}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Attempted Questions")}</th>
                        <td>
                          {participantAssessmentDetails?.attempt_question}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Correct Answers")}</th>
                        <td>{participantAssessmentDetails?.correct_answer}</td>
                      </tr>
                      <tr>
                        <th>{t("Status")}</th>
                        <td>
                          {participantAssessmentDetails?.status === 1 ? (
                            <span className="text-success">{t("Pass")}</span>
                          ) : (
                            <span className="text-danger">{t("Fail")}</span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="questions_container">
                {console.log(participantAssessmentQuestions)}
                {participantAssessmentQuestions.map((category, catIndex) => (
                  <div className="q_single" key={catIndex}>
                    <h3 className="title">{category.qn_category}</h3>
                    {category.questions.map((question, qIndex) => (
                      <div className="question" key={question.id}>
                        <div className={`q_left ${question.type}`}>
                          <h4>
                            {qIndex + 1}. {question.question}
                          </h4>
                        </div>
                        <div className="q_right">
                          <div className="button_group">
                            {question.options.map((option, optionIndex) => (
                              <label key={option.id} className="radio_label">
                                <span className="option_label">
                                  {String.fromCharCode(65 + optionIndex)}.{" "}
                                </span>
                                <input
                                  type="radio"
                                  name={`question_${question.id}`} // Ensures only one selection per question
                                  value={option.id}
                                  checked={
                                    selectedAnswers[question.id]?.optionId ===
                                    option.id
                                  }
                                  // disabled
                                />

                                {option.option}
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      )}
    </div>
  )
}

export default ViewAssessment
